import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles(() => ({
  mainInput: {
    position: "relative",
    minWidth: "200px",
  },
  inputField: {
    border: "1px solid #C4C4C4",
    borderRadius: "5px",
    fontSize: "14px !important",
    outline: "none",
    marginLeft: "4px",
    color: "#000",
    width: "100%",
    height: "100%",
    padding: "10px 0px 10px 30px",
    "&:focus": {
      border: "1px solid black",
    },
  },
  searchIcon: {
    color: "#C4C4C4",
    position: "absolute",
    top: "50%",
    left: "10%",
    transform: "translate(-50%,-50%)",
  },
}));

const SearchBar = ({ value, onChange }) => {
  const classes = useStyles();

  return (
    <Box className={classes.mainInput}>
      <SearchIcon className={classes.searchIcon} />
      <input
        type="text"
        placeholder="Search"
        className={classes.inputField}
        value={value}
        onChange={onChange}
        // onChange={(e) => onSearch(e.target.value)}
      />
    </Box>
  );
};

export default SearchBar;
